import { GameManager } from "../GameManager";
import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { BootScene } from "./BootScene";
import { Game } from "../Game";
import { AudioManager } from "./AudioManager";

export class PreloadScene extends Phaser.Scene {

    public static currentInstance: PreloadScene;

    private progressBar: Phaser.GameObjects.Image;
    private scaledItemsContainer: Phaser.GameObjects.Container;

    private background_1: Phaser.GameObjects.Graphics;

    constructor() {

        super("PreloadScene");

        PreloadScene.currentInstance = this;
    }

    public preload(): void {

        this.composeScene();

        this.loadAssets();
    }

    public create(): void {

        if (GameVars.desktop) {

            this.time.delayedCall(200, function(): void {
                GameManager.onGameAssetsLoaded();
            }, [], this); 

        } else {

            const continueText = new Phaser.GameObjects.Text(this, GameVars.gameWidth / 2, GameVars.gameHeight / 2, "Tap to start", {fontFamily: "Baloo", fontSize: "70px", color: "#265C80", align: "center"});
            continueText.setOrigin(.5);
            continueText.scaleY = GameVars.scaleY;
            continueText.setStroke("#FBDB75", 10);
            this.add.existing(continueText);

            this.tweens.add({
                targets: continueText,
                scaleX: 1.05,
                scaleY: 1.05 * GameVars.scaleY,
                ease: Phaser.Math.Easing.Linear.Linear,
                duration: 600,
                yoyo: true,
                repeat: -1
            });  
            
            this.scaledItemsContainer.visible = false;
            this.background_1.input.enabled = true;
        }   
    }
    
    private composeScene(): void {

        this.add.text(60, -42, "Continue", {fontFamily: "Supercell", fontSize: "45px", color: "#00FFC1"});

        this.background_1 = this.add.graphics();
        this.background_1.fillStyle(GameConstants.BACKGROUND_COLOR);
        this.background_1.fillRect(0, 0, GameVars.gameWidth, GameVars.gameHeight);
        this.background_1.setInteractive(new Phaser.Geom.Rectangle(0, 0, GameVars.gameWidth, GameVars.gameHeight), Phaser.Geom.Rectangle.Contains);
        this.background_1.input.enabled = false;
        this.background_1.on("pointerup", this.onMobileDown, this);
        
        this.scaledItemsContainer = this.add.container(GameVars.gameWidth / 2, 560);
        this.scaledItemsContainer.scaleY = GameVars.scaleY;

        const barWidth = 550;
        const barWHeight = 30;
        const borderWidth = 6;

        const preloadBarCapsuleBorder = new Phaser.GameObjects.Graphics(this);
        preloadBarCapsuleBorder.fillStyle(0xffffff);
        preloadBarCapsuleBorder.fillRect(0, 0, barWidth + borderWidth * 2, barWHeight + borderWidth * 2);
        preloadBarCapsuleBorder.lineStyle(4, 0x2c5a70);
        preloadBarCapsuleBorder.strokeRect(0, 0, barWidth + borderWidth * 2, barWHeight + borderWidth * 2);
        preloadBarCapsuleBorder.x = - barWidth / 2 - borderWidth;
        preloadBarCapsuleBorder.y = -borderWidth;
        this.scaledItemsContainer.add(preloadBarCapsuleBorder); 

        const preloadBarCapsule = new Phaser.GameObjects.Graphics(this);
        preloadBarCapsule.fillStyle(0xffffff);
        preloadBarCapsule.fillRect(0, 0, barWidth, barWHeight );
        preloadBarCapsule.x = - barWidth / 2;
        this.scaledItemsContainer.add(preloadBarCapsule); 

        this.progressBar = new Phaser.GameObjects.Image(this, - barWidth / 2, 0, "gradient_preload");
        this.progressBar.setOrigin(0);
        this.progressBar.scaleY = barWHeight / 256;
        this.progressBar.scaleX = 0;
        this.scaledItemsContainer.add(this.progressBar); 
    }

    private onMobileDown(): void {

        this.background_1.input.enabled = false;

        PreloadScene.currentInstance.game.scale.startFullscreen();
                
        PreloadScene.currentInstance.time.addEvent({ delay: 200, callback: () => { 

            GameVars.currentScene.game.scale.displaySize = GameVars.currentScene.game.scale.parentSize;
            Game.currentInstance.scale.refresh();

            GameVars.scaleY = (GameVars.gameHeight / GameVars.gameWidth) / (window.innerHeight / window.innerWidth);

            GameManager.onGameAssetsLoaded();
        }, callbackScope: PreloadScene.currentInstance});
}

    private loadAssets(): void {

        this.load.atlas("texture_atlas_1", "assets/texture_atlas_1.png", "assets/texture_atlas_1.json");
        
        AudioManager.init(this);

        this.load.on("progress", this.updateLoadedPercentage, this);
    }

    private updateLoadedPercentage(percentageLoaded: number): void {

        if (this.progressBar.scaleX < percentageLoaded) {
            this.progressBar.scaleX = (percentageLoaded * 550) / 8;
        }
    }
}
